// 导出相关的类型定义
// 导出状态
// 错误类型
// 配置常量
export const EXPORT_CONFIG = {
  DEFAULT_PAGE_SIZE: 1000,
  MAX_RETRY_COUNT: 3,
  RETRY_DELAY: 1000,
  MAX_PAGES: 1000
};